import { authenticated } from "./auth";

export const loadItem = async (props, getItem, emptyItem) => {
  const {
    match: {
      params: { id }
    },
    langs
  } = props;
  const auth = authenticated();
  if (auth !== undefined) {
    const { code: merchantCode, kind: merchantKind } = auth.currentMerchant;
    if (id !== "new") {
      try {
        const item = await getItem(id, merchantCode);
        return { item, merchantCode, merchantKind };
      } catch (e) {}
    } else {
      return {
        item: emptyItem(merchantCode, langs),
        merchantCode,
        merchantKind
      };
    }
  }
};



// WEBPACK FOOTER //
// ./src/services/utils.js